import { capitalizeFirstLetter, formatToYYYY_MMM_DD } from "../../../helpers/functions";
import { DataField, Divider, H2, P, Section } from "./common-components";

export const MedicalHistoryInformation = ({
  patient,
  formType,
  clinicalAssessment,
}) => {
  const allConditions = patient.medicalHistoryInfo?.medicalConditions || [];
  const confirmedConditions = allConditions.filter((condition) =>
    clinicalAssessment?.confirmedMedicalConditions?.includes(condition?.id)
  );
  
  return (
    <Section formType={formType}>
      <H2>Medical History</H2>
      <div className="space-y-2">
        {confirmedConditions.length > 0 ? (
          <>
            <table class="text-xs border border-gray-400 border-collapse w-full rounded-md">
              <thead>
                <tr class="text-left bg-gray-20">
                  <th class="border font-normal border-gray-400 p-1 w-1/2">
                    Medical Conditions
                  </th>
                  <th class="border font-normal border-gray-400 p-1 w-1/2">Symptom Control (Optional) </th>
                </tr>
              </thead>
              <tbody>
                {confirmedConditions
                  .map?.((a) => (
                    <tr className="font-semibold">
                      <td class="border border-gray-400 p-1 w-1/2">
                        {capitalizeFirstLetter(a.name)}
                      </td>
                      <td class="border border-gray-400 p-1 w-1/2">
                        {(() => {
                          const value = a.symptomControlled;
                          if (value === "controlled") return "Controlled";
                          if (value === "not controlled") return "Not Controlled";
                          if (value === "not sure") return "Not Sure Symptoms Controlled";
                          if (value === "not specified") return "Not Specified";
                          return "";
                        })()}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </>
        ) : (
          <DataField value={"No Known Medical Conditions"} />
        )}
      </div>

      <Divider />
      <div className="space-y-2">
        {patient.medicalHistoryInfo?.medicalStudies?.filter((f) =>
          clinicalAssessment?.confirmedMedicalStudies?.includes(f?.id)
        ).length > 0 ? (
          <>
            <table class="text-xs border border-gray-400 border-collapse w-full rounded-md">
              <thead>
                <tr class="text-left bg-gray-20">
                  <th class="border font-normal border-gray-400 p-1 w-1/2">
                    Medical Studies
                  </th>
                  <th class="border font-normal border-gray-400 p-1 w-1/2">Medication Name </th>
                </tr>
              </thead>
              <tbody>
                {patient.medicalHistoryInfo?.medicalStudies
                  ?.filter((f) =>
                    clinicalAssessment?.confirmedMedicalStudies?.includes(f?.id)
                  )
                  .map?.((a) => (
                    <tr className="font-semibold">
                      <td class="border border-gray-400 p-1 w-1/2">
                        {capitalizeFirstLetter(a.name)}
                      </td>
                      <td class="border border-gray-400 p-1 w-1/2">
                        {capitalizeFirstLetter(a.medicationName)}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </>
        ) : (
          <DataField value={"No Known Medical Studies"} />
        )}
      </div>

      <Divider />
      <div className="space-y-2">
        {patient.medicalHistoryInfo?.surgeries?.length > 0 ? (
          <>
            <table class="text-xs border border-gray-400 border-collapse w-full rounded-md">
              <thead>
                <tr class="text-left bg-gray-20">
                  <th class="border font-normal border-gray-400 p-1 w-1/2">
                    Surgeries/ Procedures
                  </th>
                  <th class="border font-normal border-gray-400 p-1 w-1/2">Date (Optional) </th>
                </tr>
              </thead>
              <tbody>
                {patient.medicalHistoryInfo?.surgeries
                  ?.map?.((a) => (
                    <tr className="font-semibold">
                      <td class="border border-gray-400 p-1 w-1/2">
                        {capitalizeFirstLetter(a.name)}
                      </td>
                      <td class="border border-gray-400 p-1 w-1/2">
                        {formatToYYYY_MMM_DD(a.date)}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </>
        ) : (
          <DataField value={"No Known Surgeries/ Procedures"} />
        )}
      </div>
     
    </Section>
  );
};
